import React from "react";

// RockLink's own flow chevron (the pipe-sep / .rl-live mark), doubled: work
// moving through the pipeline — what Analyst reads. Deliberately not a sparkle.
export default function AnalystGlyph({ size = 13, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
      strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M5 5l7 7-7 7" />
      <path d="M12 5l7 7-7 7" opacity="0.45" />
    </svg>
  );
}
